<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Cadastro Gerais"
      Pagina="Cadastro Gerais"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 text-center">
            <button (click)="showAcao()" class="btn btn-primary btn-lg"><i class="fa fa-money"></i> Tipo Ação</button>
            <button (click)="showDocumento()" class="btn btn-primary btn-lg"><i class="fa fa-building-o"></i> Tipo Documentos</button>
            <button (click)="showDocumentosCliente()" class="btn btn-primary btn-lg"><i class="fa fa-question"></i> Tipo Documentos Cliente</button>
            <button (click)="showTarefa()" class="btn btn-primary btn-lg"><i class="fa fa-support"></i> Tipo Tarefas</button>
          </div>
          <hr class="col-md-8" style="text-align: center;margin-left: 200px;margin-top: 30px;">
          <div style="margin-top: 20px;" *ngIf="acao" class="col-sm-12 col-md-12 col-lg-12 text-center" >
            <app-tipo-acao>
            </app-tipo-acao>
          </div>
          <div style="margin-top: 20px;" *ngIf="documento" class="col-sm-12 col-md-12 col-lg-12 text-center" >
            <app-tipo-documento>
            </app-tipo-documento>
          </div>
          <div style="margin-top: 20px;" *ngIf="tarefa" class="col-sm-12 col-md-12 col-lg-12 text-center" >
            <app-tipo-tarefa>
            </app-tipo-tarefa>
          </div>
          <div style="margin-top: 20px;" *ngIf="documentoCliente" class="col-sm-12 col-md-12 col-lg-12 text-center" >
            <app-tipo-documento-cliente>
            </app-tipo-documento-cliente>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
